import app from '$$app';

import dateFormatsHelper from '$$helpers/dateFormatsHelper';

app.on('app:start', () => {
  dateFormatsHelper.setUserDateFormat(user.dateFormat);
  dateFormatsHelper.setUserTimeFormat(user.timeFormat);
  dateFormatsHelper.setMomentLocale();
});

app.on('setUserDateFormat', (dateFormat, timeFormat) => {
  if (dateFormat) {
    user.dateFormat = dateFormat;
    dateFormatsHelper.settings.userFormat = dateFormat;
  }

  if (timeFormat) {
    user.timeFormat = timeFormat;
    dateFormatsHelper.settings.enable24 = timeFormat;
  }
});

export default dateFormatsHelper;
